module.exports = __webpack_public_path__ + "img/26.9006227e.svg";